export type NormalizedProfileUrl = {
  displayValue: string;
  href: string;
};

export const normalizeProfileUrl = (
  value: string
): NormalizedProfileUrl | null => {
  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue.toLowerCase() === 'empty') {
    return null;
  }

  // Block dangerous protocols
  if (/^(javascript|data|vbscript|file):/i.test(trimmedValue)) {
    console.error('invalid url string');
    return null;
  }
  const href =
    trimmedValue.toLowerCase().startsWith('http://') ||
    trimmedValue.toLowerCase().startsWith('https://')
      ? trimmedValue
      : `https://${trimmedValue}`;
  return { displayValue: trimmedValue, href };
};
